import { Constants } from './'

export const getSkus = id => ({
  type: Constants.SKUS_GET,
  id
})

export const getSkusSuccess = payload => ({
  type: Constants.SKUS_GET_SUCCESS,
  payload
})

export const getSkusFailure = (message, data) => ({
  type: Constants.SKUS_GET_FAILURE,
  payload: {
    message,
    data
  }
})

export const selectSku = payload => ({
  type: Constants.SKU_SELECT,
  payload
})
